{
  "feedback-process-pages": {
    "feedback-process-steps": {
      "step-1": {
        "title": "Ihre Zufriedenheit",
        "description": "Sind Sie mit unserem Service zufrieden?"
      },
      "step-2": {
        "title": "Ihr Feedback",
        "description": "Schreiben Sie Ihr Feedback"
      },
      "step-3": {
        "title": "Feedback gesendet",
        "description": "Ihr Feedback wurde gesendet"
      }
    },
    "meta": {
      "title": "Bewertung",
      "description": "Ihr Feedback"
    }
  }
}
